import { Store } from '@shared/types/store';
import { Store as EntityStore } from '@/types/entity/business-unit';

export const mapStore = ({ storeId, key, name, productSelectionKeys }: Store): EntityStore => {
  return {
    id: storeId as string,
    key: key ?? '',
    name: name ?? key ?? '',
    ...(productSelectionKeys && productSelectionKeys.length > 0 ? { productSelectionKeys } : {}),
  };
};
